<template>
  <div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']">
    <div class="ptn-title" @click="$router.go(-1)" >
      <img :src="require('@/assets/images/goodsCon-goback.png')" />
    </div>
    <product-con-swiper :img-urls="storeInfo.slider_image"></product-con-swiper>
    <div class="wrapper">
      <div class="share">
        <div class="money">

          <div class="num" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'>
            <div class="wrapper"></div>
          </div>
          <div class="num" v-else>
            <div>{{ storeInfo.price }}</div>
          </div>
        </div>
        <!-- <div class="iconfont icon-fenxiang" @click="listenerActionSheet"></div> -->
      </div>
      <div class="introduce">{{ storeInfo.store_name }}</div>
      <div
        style="margin: 0.1rem 0.3rem 0 0.3rem; font-size: 0.2rem; color: #999"
        v-if="id == 411"
      >
        近日北京区域物流刀具管控，暂无法邮寄。<br />
        待管控结束后第一时间安排发货配送，感谢您的理解。
      </div>
      <div
        class="wrapper"
        v-if="couponsList[0] && couponsList[0].coupon_type == 2"
      ></div>
      <div class="label acea-row row-between-wrapper" v-else>
          <!-- <div>原价:{{ storeInfo.ot_price }}</div> -->
          <div v-if="storeInfo.fsales || storeInfo.unit_name">销量:{{ storeInfo.fsales }}{{ storeInfo.unit_name }}</div>
          <div v-if="storeInfo.stock || storeInfo.unit_name">库存:{{ storeInfo.stock }}{{ storeInfo.unit_name }}</div>
      </div>
    </div>
    <div class="attribute acea-row row-between-wrapper" @click="selecAttrTap">
      <div>
        {{ attrTxt }}：<span class="atterTxt">{{ attrValue }}</span>
      </div>
      <div class="iconfont icon-jiantou"></div>
    </div>
    <div class="userEvaluation" v-if="replyCount">
      <div class="title acea-row row-between-wrapper">
        <div>用户评价({{ replyCount }})</div>
        <router-link :to="{ path: '/evaluate_list/' + id }" class="praise"
          ><span class="font-color-red">{{ replyChance }}%</span>好评率<span
            class="iconfont icon-jiantou"
          ></span
        ></router-link>
      </div>
      <user-evaluation :reply="reply"></user-evaluation>
    </div>
    <div class="product-intro">
      <div class="title">
        <div class="page-inline-block page-relative icon-line-left">
          <span class="page-absolute circular"></span>
        </div>
        <span style="margin:0 0.16rem;">产品介绍</span>
        <div class="page-inline-block page-relative icon-line-right">
          <span class="page-absolute circular"></span>
        </div>
      </div>
      <div class="conter" v-html="storeInfo.description"></div>
    </div>
    <div style="height: 1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="item" @click="$router.push({ path: '/home' })">
        <div class="iconfont">
          <img class="page-image" :src="require('@/assets/images/footer-icon1.png')" />
        </div>
        <div>首页</div>
      </div>
      <router-link
        :to="'/cart'"
        class="item animated"
        :class="animated === true ? 'bounceIn' : ''"
      >
        <div class="iconfont icon-gouwu">
          <img class="page-image" :src="require('@/assets/images/footer-icon2.png')" />
          <span class="num bg-color-red" v-if="CartCount > 0">{{
            CartCount
          }}</span>
        </div>
        <div>购物车</div>
      </router-link>
      <div class="bnt acea-row">
        <div class="joinCart" @click="joinCart">加入购物车</div>
        <div class="buy" @click="tapBuy">立即兑换</div>
      </div>
    </div>
    <!--<Share-red-packets
      :priceName="priceName"
      v-on:changeFun="changeFun"
      v-if="priceName !== 0"
    ></Share-red-packets>-->
    <CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop>
    <Product-window
      v-on:changeFun="changeFun"
      :attr="attr"
      :couponsList="couponsList"
    ></Product-window>
    <MultipleSpecifications
      v-on:changeFun="changeFun"
      :attr="multipleInfo"
      :couponsList="couponsList"
    ></MultipleSpecifications>
    <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>

    <div
      class="generate-posters acea-row row-middle"
      :class="posters ? 'on' : ''"
    >
      <div
        class="item"
        v-if="weixinStatus === true"
        @click="setShareInfoStatus"
      >
        <div class="iconfont icon-weixin3"></div>
        <div class="">发送给朋友</div>
      </div>
      <div class="item" @click="setPosterImageStatus">
        <div class="iconfont icon-haibao"></div>
        <div class="">生成海报</div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    ></div>
  </div>
</template>
<style>
.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.noscroll {
  height: 100%;
  overflow: hidden;
}
.introduce {
  margin: 0.04rem 0.3rem;
  font-size: .4rem;
  font-weight: 550;
}
</style>
<script>
import ProductConSwiper from "@components/ProductConSwiper";
import UserEvaluation from "@components/UserEvaluation";
//import ShareRedPackets from "@components/ShareRedPackets";
import CouponPop from "@components/CouponPop";
import ProductWindow from "@components/ProductWindow";
import MultipleSpecifications from "@components/MultipleSpecifications";
import StorePoster from "@components/StorePoster";
import ShareInfo from "@components/ShareInfo";
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getCouponsUser,
} from "@api/user";
import { imageBase64 } from "@api/public";
import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
export default {
  name: "GoodsCon",
  components: {
    ProductConSwiper,
    UserEvaluation,
    //  ShareRedPackets,
    CouponPop,
    ProductWindow,
    StorePoster,
    ShareInfo,
    MultipleSpecifications,
  },
  data: function () {
    return {
      shareInfoStatus: false,
      weixinStatus: false,
      couponsList: [],
      posterData: {
        image: "",
        title: "",
        price: "",
        code: "",
      },
      posterImageStatus: false,
      animated: false,
      coupon: {
        coupon: false,
        list: [],
      },
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {},
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {},
      couponList: [],
      attrTxt: "请选择",
      attrValue: "",
      cart_num: 1, //购买数量
      replyCount: "",
      replyChance: "",
      reply: [],
      priceName: 0,
      CartCount: 0,
      posters: false,
      showTit: false,
      checkData: {},
      // 新增套餐多规格
      isMultiple: false, //是否是多规格商品
      multipleInfo: {
        cartAttr: false,
        productAttr: [],
        productSelect: {},
        selectList: [],
      },
      multValue: {}
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: async function () {
    this.id = this.$route.params.id;
    await getCouponsUser(0).then((res) => {
      this.couponsList = res.data;
    });
    await this.productCon();
    this.coupons();
  },
  methods: {
    showAllhide() {
      this.showTit = false;
    },
    showTitFun() {
      // console.log(111)
      this.showTit = true;
    },
    updateTitle() {
      document.title = this.storeInfo.store_name || this.$route.meta.title;
    },
    setShareInfoStatus: function () {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    shareCode: function () {
      var that = this;
      getProductCode(that.id).then((res) => {
        that.posterData.code = res.data.code;
        //that.listenerActionSheet();
      });
    },
    setPosterImageStatus: function () {
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    //产品详情接口；
    productCon: function () {
      let that = this;
      getProductDetail(that.id)
        .then((res) => {
          that.$set(that, "storeInfo", res.data.storeInfo);
          // 判断是否是多规格商品
          if (
            res.data.packageProductAttr &&
            res.data.packageProductAttr.length > 0
          ) {
            that.isMultiple = true;
            that.$set(
              that.multipleInfo,
              "productAttr",
              res.data.packageProductAttr
            );
            that.$set(that, "multValue", res.data.productValue);
          } else {
            that.isMultiple = false;
            that.$set(that.attr, "productAttr", res.data.productAttr);
            that.$set(that, "productValue", res.data.productValue);
          }
          that.$set(that, "replyCount", res.data.replyCount);
          that.$set(that, "replyChance", res.data.replyChance);
          that.reply = res.data.reply ? [res.data.reply] : [];
          that.$set(that, "reply", that.reply);
          that.$set(that, "priceName", res.data.priceName);
          that.posterData.image = that.storeInfo.image_base;
          if (that.storeInfo.store_name.length > 30) {
            that.posterData.title =
              that.storeInfo.store_name.substring(0, 30) + "...";
          } else {
            that.posterData.title = that.storeInfo.store_name;
          }
          that.posterData.price = that.storeInfo.price;
          that.posterData.code = that.storeInfo.code_base;
          if (that.isLogin) this.shareCode();
          that.updateTitle();
          that.DefaultSelect();
          that.getCartCount();
          that.getImageBase64();
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
    },
    getImageBase64: function () {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code)
        .then((res) => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    //默认选中属性；
    DefaultSelect: function () {
      // 如果是套餐商品
      if (this.isMultiple) {
        this.$set(
          this.multipleInfo.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(
          this.multipleInfo.productSelect,
          "image",
          this.storeInfo.image
        );
        this.$set(
          this.multipleInfo.productSelect,
          "price",
          this.storeInfo.price
        );
        this.$set(
          this.multipleInfo.productSelect,
          "stock",
          this.storeInfo.stock
        );
        this.$set(
          this.multipleInfo.productSelect,
          "unique",
          this.storeInfo.unique || ""
        );
        this.$set(this.multipleInfo.productSelect, "cart_num", 1);
        let pro_attr = this.multipleInfo.productAttr;
        let select_attr = [];
        for (let i = 0; i < pro_attr.length; i++) {
          let val_attr;
          let default_val = "";
          let select_unique = "";
          // 无法识别规格排列组合后的前后顺序
          let _productValue = pro_attr[i] && pro_attr[i].productValue;
          let _list = (_productValue && Object.values(_productValue)) || [];
          val_attr = _list.length > 0 ? _list[0] : null;

          default_val = val_attr && val_attr.suk;
          select_unique = val_attr && val_attr.unique;
          if (val_attr) {
            select_attr.push({
              packages_id: pro_attr[i] && pro_attr[i].product.packages_id,
              product_id: pro_attr[i] && pro_attr[i].product.id,
              attr: default_val,
              unique: select_unique,
            });
          } else {
            select_attr.push({
              packages_id: "",
              product_id: "",
              attr: "",
              unique: ""
            });
          }
        }
        let attrValueText = "";
        select_attr.forEach((val) => {
          attrValueText = val.attr
            ? attrValueText + val.attr + ","
            : attrValueText + "";
        });
        // console.log(select_attr,"select_attr");
        this.$set(this.multipleInfo, "selectList", select_attr);
        this.$set(this, "attrValue", attrValueText);
        this.$set(this, "attrTxt", "已选择");
      } else {
        let productAttr = this.attr.productAttr;
        let value = [];
        for (let i = 0; i < productAttr.length; i++) {
          this.$set(productAttr[i], "index", 0);
          value.push(productAttr[i].attr_values[0]);
        }
        //sort();排序函数:数字-英文-汉字；

        // let holdData = this.filterData(value);
        // let filter_value = (holdData.length && holdData[0]) || "";
        let filter_value = value.join(",");

        let productSelect = this.productValue[filter_value];
        this.$set(this, "checkData", productSelect);
        if (productSelect && productAttr.length) {
          this.$set(
            this.attr.productSelect,
            "store_name",
            this.storeInfo.store_name
          );
          this.$set(this.attr.productSelect, "image", productSelect.image);
          this.$set(this.attr.productSelect, "price", productSelect.price);
          this.$set(this.attr.productSelect, "stock", productSelect.stock);
          this.$set(this.attr.productSelect, "unique", productSelect.unique);
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "attrValue", value.join(","));
          this.$set(this, "attrTxt", "已选择");
        } else if (!productSelect && productAttr.length) {
          this.$set(
            this.attr.productSelect,
            "store_name",
            this.storeInfo.store_name
          );
          this.$set(this.attr.productSelect, "image", this.storeInfo.image);
          this.$set(this.attr.productSelect, "price", this.storeInfo.price);
          this.$set(this.attr.productSelect, "stock", 0);
          this.$set(this.attr.productSelect, "unique", "");
          this.$set(this.attr.productSelect, "cart_num", 0);
          this.$set(this, "attrValue", "");
          this.$set(this, "attrTxt", "请选择");
        } else if (!productSelect && !productAttr.length) {
          this.$set(
            this.attr.productSelect,
            "store_name",
            this.storeInfo.store_name
          );
          this.$set(this.attr.productSelect, "image", this.storeInfo.image);
          this.$set(this.attr.productSelect, "price", this.storeInfo.price);
          this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
          this.$set(
            this.attr.productSelect,
            "unique",
            this.storeInfo.unique || ""
          );
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "attrValue", "");
          this.$set(this, "attrTxt", "请选择");
        }
      }
    },
    // 筛选数据
    filterData(value) {
      // 这个筛选是由于最初选择多规格单品时选好的值跟数据返回的值因排序问题对不上号使用的，后续出现当有相同属性值时无法筛选的情况，
      // 而后调整接口生成数据顺序之后 直接连接字符串对应数据值 此部分暂时注释-预备有兼容新老商品数据的情况
      let screen = [];
      if (value.length > 0) {
        let arr_productValues = Object.keys(this.productValue);
        //
        // for (let m = 0; m < value.length; m++) {
        //   if (screen.length == 0) {
        //     for (let l = 0; l < arr_productValues.length; l++) {
        //       if (arr_productValues[l].indexOf(value[m]) !== -1) {
        //         screen.push(arr_productValues[l]);
        //       }
        //     }
        //   } else {
        //     let arr_sim = [];
        //     for (let s = 0; s < screen.length; s++) {
        //       if (screen[s].indexOf(value[m]) !== -1) {
        //         arr_sim.push(screen[s]);
        //       }
        //       if (s == screen.length - 1) {
        //         screen = arr_sim;
        //       }
        //     }
        //   }
        // }
        // return screen;
        //
        let _val = value.join(',');//sort()
        let _scr = [];
        for (let l = 0; l < arr_productValues.length; l++) {
          if (arr_productValues[l].indexOf(_val) !== -1) {
            _scr.push(arr_productValues[l]);
          }
        }
        return _scr;
      } else {
        return [];
      }
    },
    //购物车；
    ChangeCartNum: function (changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.checkData;
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.stock || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock);
          this.$set(this, "cart_num", stock);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    // 多规格 购物车
    changeMultCartNum(val) {
      let num = this.multipleInfo.productSelect;
      let stock = this.multipleInfo.productSelect.stock || 0;
      if (val) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.multipleInfo.productSelect, "cart_num", stock);
          this.$set(this, "cart_num", stock);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.multipleInfo.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function (opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //打开优惠券插件；
    couponTap: function () {
      let that = this;
      that.coupons();
      that.coupon.coupon = true;
    },
    changecoupon: function (msg) {
      this.coupon.coupon = msg;
      this.coupons();
    },
    currentcoupon: function (res) {
      let that = this;
      that.coupon.coupon = false;
      that.$set(that.coupon.list[res], "is_use", true);
    },
    //可领取优惠券接口；
    coupons: function () {
      let that = this,
        q = { page: 1, limit: 20 };
      getCoupon(q).then((res) => {
        that.$set(that, "couponList", res.data || []);
        that.$set(that.coupon, "list", res.data);
      });
    },
    //打开属性插件；
    selecAttrTap: function () {
      if (this.isMultiple) {
        this.multipleInfo.cartAttr = true;
        this.isOpen = true;
      } else {
        this.attr.cartAttr = true;
        this.isOpen = true;
      }
    },
    changeattr: function (msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    //选择属性；
    ChangeAttr: function (res) {
      // let holdData = this.filterData(res);
      // let filter_value = (holdData.length && holdData[0]) || "";
      let filter_value = res.join(",");
      //
      let productSelect = this.productValue[filter_value];
      // console.log(res, "=原来", productSelect.suk, "=选择的属性");
      this.$set(this, "checkData", productSelect);
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", res.join(","));
        this.$set(this, "attrTxt", "已选择");
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },

    // 多规格开关
    ischangemultiple(msg) {
      this.multipleInfo.cartAttr = msg;
      this.isOpen = false;
    },
    // 多规格选择属性
    ChangeMultiple(res) {
      let values = res;
      let _list = this.multipleInfo.selectList;
      for (let i = 0; i < _list.length; i++) {
        if (values.id == _list[i].product_id) {
          this.$set(this.multipleInfo.selectList[i], "attr", values.val);
          this.$set(this.multipleInfo.selectList[i], "unique", values.que);
        }
      }
      let itemVal = this.multipleInfo.selectList.reduce((v, i) => {
        return i.attr ? v + i.attr + "," : v + "";
      }, "");
      this.$set(this, "attrValue", itemVal);
      this.$set(this, "attrTxt", "已选择");
      // console.log(res, " -res- ", this.multipleInfo.selectList);
    },
    //收藏商品
    setCollect: function () {
      let that = this,
        id = that.storeInfo.id,
        category = "product";
      if (that.storeInfo.userCollect) {
        getCollectDel(id, category).then(function () {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      } else {
        getCollectAdd(id, category).then(function () {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      }
    },
    //  点击加入购物车按钮
    joinCart: function () {
      if (this.isMultiple) {
        this.goCatMultiple(0);
      } else {
        //0=加入购物车
        this.goCat(0);
      }
    },
    // 多规格加入购物车
    goCatMultiple(val) {
      // console.log("多规格购买")
      if (this.attrValue) {
        this.multipleInfo.cartAttr = !this.isOpen ? true : false;
      } else {
        if (this.isOpen) this.multipleInfo.cartAttr = true;
        else this.multipleInfo.cartAttr = !this.multipleInfo.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (this.multipleInfo.cartAttr === true && this.isOpen === false)
        return (this.isOpen = true);
      // console.log(this.multipleInfo.productSelect.unique,"this.multipleInfo.productSelect.unique")
      let uniq = (Object.keys(this.multValue).length > 0 && Object.values(this.multValue)[0].unique) || "";
      let list_select = this.multipleInfo.selectList && this.multipleInfo.selectList.filter((v)=> v.packages_id && v.packages_id);
      let q = {
        productId: this.id,
        cartNum: this.multipleInfo.productSelect.cart_num,
        new: val,
        uniqueId: uniq || "",
        packagesAttr: list_select || [],
      };
      let that = this;
      postCartAdd(q)
        .then(function (res) {
          that.isOpen = false;
          that.multipleInfo.cartAttr = false;
          if (val) {
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功",
              callback: () => {
                that.getCartCount(true);
              },
            });
          }
        })
        .catch((res) => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    // 加入购物车；
    goCat: function (news) {
      let that = this,
        productSelect = that.checkData;
      //打开属性
      if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.attr.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.attr.cartAttr = true;
        else that.attr.cartAttr = !that.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (that.attr.cartAttr === true && that.isOpen === false)
        return (that.isOpen = true);
      //如果有属性,没有选择,提示用户选择
      if (
        that.attr.productAttr.length &&
        productSelect === undefined &&
        that.isOpen === true
      )
        return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
      let q = {
        productId: that.id,
        cartNum: that.attr.productSelect.cart_num,
        new: news,
        uniqueId:
          that.attr.productSelect !== undefined
            ? that.attr.productSelect.unique
            : "",
      };
      postCartAdd(q)
        .then(function (res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功",
              callback: () => {
                that.getCartCount(true);
              },
            });
          }
        })
        .catch((res) => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    //获取购物车数量
    getCartCount: function (isAnima) {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartCount({ numType: 0 }).then((res) => {
          that.CartCount = res.data.count;
          //加入购物车后重置属性
          if (isAnima) {
            that.animated = true;
            setTimeout(function () {
              that.animated = false;
            }, 500);
          }
        });
      }
    },
    //立即购买；
    tapBuy: function () {
      if (this.isMultiple) {
        this.goCatMultiple(1);
      } else {
        //  1=直接购买
        this.goCat(1);
      }
    },
    listenerActionSheet: function () {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose: function () {
      this.posters = false;
    },
  },
};
</script>